import React from 'react';
import ReactDOM from 'react-dom';
import { StoreContext } from './app.context';
import { store } from './app.store';
import { BrowserRouter as Router } from 'react-router-dom';
import { App } from './modules';
import 'animate.css';
import './styles/globals.scss';
import 'swiper/scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

ReactDOM.render(
  <React.StrictMode>
    <StoreContext.Provider value={store}>
      <Router>
        <App />
      </Router>
    </StoreContext.Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
